module.exports = `
  (function(a,b,c,d){
    a='//tags.tiqcdn.com/utag/porsche/porsche.nl/prod/utag.js';
    b=document;c='script';d=b.createElement(c);d.src=a;d.type='text/java'+c;d.async=true;
    a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a);
  })();
`;
